module.exports = __webpack_public_path__ + "static/media/15.b5d13068.jpg";